import "../../assets/css/grid.scss";
import "../../assets/css/grid.scss";
import "../../assets/css/style.scss";
import logo from '../../assets/images/logo.png';
import { Link } from "react-router-dom";

function SendOtp() {
  return (
    <div className="App">
      <div className="col-lg-100 col-md-100 col-sm-100 full-height pt-40">
        <div className="login pt-40">
          <div className="logo">
          <img  src={logo} alt="" />
          </div>
          <div className="login-title">
          <h1>Password reset</h1>
          <h6>We sent a code to <b>vijayk@nomail.com</b></h6>
          </div>
        

        <form className="login-form">
          <div className="login-input">
            <label for=""> OTP</label>
            <input type="text" placeholder="OTP" required />
        </div>

         
          <div className="errors">
            <h1>Please check your Username or password</h1>
          </div>

         
          <div className="login-input">
            <button type="submit"> Sign In</button>
          </div>
          </form>
          <div className="login-footer">
            <p>Don't have an account  <a >  <Link to="/Plans#plans">Signup for free</Link></a></p>

          </div>

        </div>
      </div>

      
    </div>
  );
}

export default SendOtp;